import { PricelistCreatePage } from '@/features/pricelist/pages/PricelistCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pricelist/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pricelist.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PricelistCreatePage,
})
